module.exports = __webpack_public_path__ + "static/mysa-mattress-4-d9806ec7ec544af59254a2ce5c49b89f.png";